import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Seo from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <>
      <Seo title="Checkout Cancelled" path="/payment/cancel" />
      <div className="min-h-screen flex items-center justify-center px-5 py-32 bg-transparent grain">
        <div className="card-lux p-10 md:p-14 max-w-lg w-full text-center relative z-[2]">
          <XCircle size={56} className="text-neutral-400 mx-auto mb-6" />
          <h1 className="font-serif text-4xl text-neutral-900">Checkout Cancelled</h1>
          <p className="text-neutral-500 mt-3">No worries — your card was not charged. Your spot is still available.</p>
          <Link to="/buy-tickets" data-testid="cancel-retry" className="btn-gold mt-8 inline-flex">Try Again</Link>
        </div>
      </div>
    </>
  );
}
